<template>
    <div :style="{'height' : height + 'px'}">

        <div :style="{ visibility: (loading) ? 'hidden' : 'inherit'}">
            <slot></slot>
        </div>

        <v-overlay absolute opacity="1" style="z-index: 8;" :value="loading" color="loaderbg">
            <v-progress-circular indeterminate color="accent" size="36"></v-progress-circular>
        </v-overlay>

    </div>
</template>

<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                default: true
            },
            height: {
                type: Number,
                default: 300
            }
        },
    }
</script>